(function () {
  if (window.__nbInit) return;
  window.__nbInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.nb-reveal:not(.nb-visible), .nb-hero:not(.nb-visible)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nb-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('nb-visible');
            observer.unobserve(e.target);
          }
        });
      }, { threshold: 0.15 });
    }
    els.forEach(function (el) { observer.observe(el); });
    // Red de seguridad: lo que ya está en pantalla nunca se queda invisible.
    setTimeout(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('nb-visible');
      });
    }, 500);
  }

  function initContadores(root) {
    (root || document).querySelectorAll('[data-nb-contar]').forEach(function (el) {
      if (el.dataset.nbInit) return;
      el.dataset.nbInit = '1';
      var fin = parseFloat(el.dataset.nbContar) || 0;
      if (reduce || !('IntersectionObserver' in window)) { el.textContent = fin; return; }
      el.textContent = '0';
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var t0 = null, dur = 1400;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var v = fin * (1 - Math.pow(1 - p, 3));
          el.textContent = fin % 1 ? v.toFixed(1) : Math.round(v);
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  function initColores(root) {
    (root || document).querySelectorAll('.nb-colores').forEach(function (sec) {
      if (sec.dataset.nbInit) return;
      sec.dataset.nbInit = '1';
      var imgs = sec.querySelectorAll('.nb-colores__escena img');
      var nombre = sec.querySelector('.nb-colores__nombre');
      sec.querySelectorAll('.nb-swatch').forEach(function (b, i) {
        b.addEventListener('click', function () {
          sec.querySelectorAll('.nb-swatch').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          imgs.forEach(function (im, j) { im.classList.toggle('nb-activa', j === i); });
          if (nombre) nombre.textContent = b.dataset.nombre || '';
        });
      });
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('.nb-faq__item').forEach(function (it) {
      if (it.dataset.nbInit) return;
      it.dataset.nbInit = '1';
      var btn = it.querySelector('.nb-faq__pregunta');
      btn.addEventListener('click', function () {
        var abierto = it.classList.toggle('nb-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function formatoDinero(centavos, formato) {
    var valor = (centavos / 100);
    var entero = Math.round(valor).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var conDec = valor.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (formato || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, entero)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, entero.replace(/\./g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conDec)
      .replace(/\{\{\s*amount\s*\}\}/, valor.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/[.,]00(?!\d)/, '');
  }

  function initProducto(root) {
    (root || document).querySelectorAll('.nb-prod').forEach(function (sec) {
      if (sec.dataset.nbInit) return;
      sec.dataset.nbInit = '1';
      var principal = sec.querySelector('.nb-prod__principal img');
      var minis = sec.querySelectorAll('.nb-prod__miniaturas button');
      function verFoto(src, boton) {
        if (!principal || !src) return;
        principal.src = src;
        minis.forEach(function (m) { m.setAttribute('aria-current', m === boton ? 'true' : 'false'); });
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { verFoto(m.dataset.src, m); }); });

      var datos = sec.querySelector('[data-nb-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var formato = sec.dataset.formato;
      var inputId = sec.querySelector('input[name="id"]');
      var precio = sec.querySelector('.nb-prod__precio');
      var boton = sec.querySelector('.nb-prod__comprar');
      var textoBoton = boton ? boton.textContent : '';
      var textoAgotado = sec.dataset.agotado || 'Agotado';

      function seleccion() {
        var vals = [];
        sec.querySelectorAll('.nb-prod__opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          vals.push(c ? c.value : null);
          var etiqueta = fs.querySelector('legend span');
          if (etiqueta && c) etiqueta.textContent = c.value;
        });
        return vals;
      }
      function actualizar() {
        var vals = seleccion();
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === vals[i]; });
        });
        if (!v) {
          if (boton) { boton.disabled = true; boton.textContent = 'No disponible'; }
          return;
        }
        inputId.value = v.id;
        if (precio) {
          var html = formatoDinero(v.price, formato);
          if (v.compare_at_price && v.compare_at_price > v.price) html += ' <s>' + formatoDinero(v.compare_at_price, formato) + '</s>';
          precio.innerHTML = html;
        }
        if (boton) { boton.disabled = !v.available; boton.textContent = v.available ? textoBoton : textoAgotado; }
        if (v.featured_image && v.featured_image.src) verFoto(v.featured_image.src, null);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      sec.querySelectorAll('.nb-prod__opcion input').forEach(function (inp) { inp.addEventListener('change', actualizar); });
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(root);
    initContadores(root);
    initColores(root);
    initFaq(root);
    initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
